import { render } from "./FleetRealtime.vue?vue&type=template&id=b6a52b40&scoped=true"
import script from "./FleetRealtime.vue?vue&type=script&lang=js"
export * from "./FleetRealtime.vue?vue&type=script&lang=js"

import "./FleetRealtime.vue?vue&type=style&index=0&id=b6a52b40&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a52b40"]])

export default __exports__